// Prompt libre y Creador de video abren Crear (Redes) en escritorio —
// ADR-2026-10-07-prompt-libre-y-creador-abren-crear. Crear ya hace lo de los dos
// (ADR-2026-10-01-modo-redes); en la home de siempre esos dos modos son su puerta. En el
// teléfono no: Redes es sólo de computadora, y los sheets de siempre siguen.
//
// Puro, para testearlo: la navegación la hace `InterfazV2` (un solo punto que cubre la
// home, la sidebar, `/modos`, el agente y los deep links) y la lectura `PantallaRedes`.

import type { Medio, ModoDeCrear } from './redes';

/** Qué medio abre cada uno de los dos modos viejos. */
const MEDIO_POR_MODO: Readonly<Record<string, Medio>> = {
  'prompt-libre': 'imagen',
  'creador-video': 'video',
};

/** A dónde va `/interfaz-v2/modo/:mode`, o `null` si se queda donde está. */
export function destinoEnCrear(
  routeMode: string | undefined,
  esEscritorio: boolean,
): { medio: Medio } | null {
  if (!esEscritorio || !routeMode) return null;
  const medio = MEDIO_POR_MODO[routeMode];
  return medio ? { medio } : null;
}

/** El medio que pidió quien navegó a Redes (`state.medio`), o nada. */
export function medioDeEntrada(state: unknown): Medio | null {
  const medio = (state as { medio?: unknown } | null | undefined)?.medio;
  return medio === 'video' || medio === 'imagen' ? medio : null;
}

/**
 * El modo de Crear que pidió quien navegó a Redes (`state.modo`), o nada. Lo manda la card
 * "Imagen automática" del popup de Redes sociales, que abre Crear con ese modo elegido
 * (ADR-2026-10-12-imagen-automatica-en-el-popup-de-redes).
 */
export function modoDeEntrada(state: unknown): ModoDeCrear | null {
  const modo = (state as { modo?: unknown } | null | undefined)?.modo;
  return modo === 'automatico' || modo === 'animar' ? modo : null;
}

/**
 * El mismo estado de navegación sin `medio` ni `modo`, para que recargar la pestaña no los
 * vuelva a aplicar; `null` si no queda nada (como lo deja el resto de la pantalla).
 */
export function estadoSinMedio(state: unknown): Record<string, unknown> | null {
  if (!state || typeof state !== 'object') return null;
  const { medio: _medio, modo: _modo, ...resto } = state as Record<string, unknown>;
  return Object.keys(resto).length ? resto : null;
}
